"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatComposerAddMenu = ChatComposerAddMenu;
var _react = require("react");
var _lucideReact = require("lucide-react");
var _materialSymbols = require("@design/icons/material-symbols");
var _dropdownMenu = require("@design/ui/dropdown-menu");
var _button = require("@design/ui/button");
var _ModelSelectionDropdown = require("../ModelSelectionDropdown");
var _chatComposerPastChatsList = require("./chat-composer-past-chats-list");
var _customizeAgentDialog = require("./customize-agent-dialog");
var _analytics = require("../../analytics");
var _jsxRuntime = require("react/jsx-runtime");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LIBRARY_MENU_ENTRIES = [{
  tab: "prompts",
  label: "Prompts",
  icon: _materialSymbols.FormatAlignLeftIcon
}, {
  tab: "skills",
  label: "Skills",
  icon: _materialSymbols.FunctionsIcon
}, {
  tab: "clauses",
  label: "Clauses",
  icon: _materialSymbols.WrapTextIcon
}, {
  tab: "memories",
  label: "Memories",
  icon: _lucideReact.Brain
}];
function modelTriggerLabel(model) {
  var _MODEL_OPTIONS$find$l, _MODEL_OPTIONS$find;
  var optionLabel = (_MODEL_OPTIONS$find$l = (_MODEL_OPTIONS$find = _ModelSelectionDropdown.MODEL_OPTIONS.find(function (option) {
    return option.value === model;
  })) === null || _MODEL_OPTIONS$find === void 0 ? void 0 : _MODEL_OPTIONS$find.label) !== null && _MODEL_OPTIONS$find$l !== void 0 ? _MODEL_OPTIONS$find$l : model;
  return optionLabel.replace(/^Claude /, "");
}
function ChatComposerAddMenu(_ref) {
  var menuSide = _ref.menuSide,
    chatArtifacts = _ref.chatArtifacts,
    onMenuOpen = _ref.onMenuOpen,
    onAttachFile = _ref.onAttachFile,
    pastChats = _ref.pastChats,
    onOpenLibrary = _ref.onOpenLibrary,
    onNewConversation = _ref.onNewConversation,
    customizeAgent = _ref.customizeAgent,
    model = _ref.model,
    onOpenChatHistory = _ref.onOpenChatHistory,
    analytics = _ref.analytics;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCustomizeAgentDialogOpen = _useState2[0],
    setIsCustomizeAgentDialogOpen = _useState2[1];
  function handleOpenLibrary(tab) {
    onOpenLibrary(tab);
    (0, _analytics.trackChatComposerEvent)(analytics, {
      name: "chat_composer_library_opened",
      tab: tab
    });
  }
  function handleModelChange(selectedModel) {
    model === null || model === void 0 || model.onChange(selectedModel);
    (0, _analytics.trackChatComposerEvent)(analytics, {
      name: "chat_composer_model_selected",
      model: selectedModel
    });
  }
  function handleAgentSettingsSaved() {
    return _handleAgentSettingsSaved.apply(this, arguments);
  }
  function _handleAgentSettingsSaved() {
    _handleAgentSettingsSaved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            (0, _analytics.trackChatComposerEvent)(analytics, {
              name: "chat_composer_agent_settings_saved"
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleAgentSettingsSaved.apply(this, arguments);
  }
  function renderLibraryEntry(_ref2) {
    var tab = _ref2.tab,
      label = _ref2.label,
      Icon = _ref2.icon;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
      onSelect: function onSelect() {
        return handleOpenLibrary(tab);
      },
      "data-sentry-element": "DropdownMenuItem",
      "data-sentry-component": "renderLibraryEntry",
      "data-sentry-source-file": "chat-composer-add-menu.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        "data-sentry-element": "Icon",
        "data-sentry-source-file": "chat-composer-add-menu.tsx"
      }), label, /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
        className: "ml-auto",
        "data-sentry-element": "ChevronRightIcon",
        "data-sentry-source-file": "chat-composer-add-menu.tsx"
      })]
    }, tab);
  }
  function renderPastChatsEntry() {
    if (pastChats.kind === "sheet") {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
        onSelect: pastChats.onOpen,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChatIcon, {}), "Attach past chat", /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
          className: "ml-auto"
        })]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuSub, {
      "data-sentry-element": "DropdownMenuSub",
      "data-sentry-component": "renderPastChatsEntry",
      "data-sentry-source-file": "chat-composer-add-menu.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuSubTrigger, {
        "data-sentry-element": "DropdownMenuSubTrigger",
        "data-sentry-source-file": "chat-composer-add-menu.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChatIcon, {
          "data-sentry-element": "ChatIcon",
          "data-sentry-source-file": "chat-composer-add-menu.tsx"
        }), "Past Chats"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuSubContent, {
        className: "w-[388px]",
        "data-sentry-element": "DropdownMenuSubContent",
        "data-sentry-source-file": "chat-composer-add-menu.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatComposerPastChatsList.ChatComposerPastChatsList, _objectSpread(_objectSpread({}, pastChats.list), {}, {
          "data-sentry-element": "ChatComposerPastChatsList",
          "data-sentry-source-file": "chat-composer-add-menu.tsx"
        }))
      })]
    });
  }
  var modelSubmenu = model ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuSub, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuSubTrigger, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SwapHorizIcon, {}), modelTriggerLabel(model.value)]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuSubContent, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuRadioGroup, {
        value: model.value,
        onValueChange: handleModelChange,
        children: _ModelSelectionDropdown.MODEL_OPTIONS.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuRadioItem, {
            value: option.value,
            children: option.label
          }, option.value);
        })
      })
    })]
  }) : null;
  var newChatArtifactDot = chatArtifacts !== null && chatArtifacts !== void 0 && chatArtifacts.hasNewArtifact ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-testid": "chat-artifacts-new-dot",
    className: "size-2 rounded-full bg-colors-sky-500",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "sr-only",
      children: "New"
    })
  }) : null;
  var chatArtifactsItem = chatArtifacts ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
    onSelect: chatArtifacts.onOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ContentCopyIcon, {}), "Chat Artifacts", newChatArtifactDot]
  }) : null;
  var leadingSection = chatArtifactsItem ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [chatArtifactsItem, /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuSeparator, {})]
  }) : null;
  var newConversationItem = onNewConversation ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
    onSelect: onNewConversation,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddCommentIcon, {}), "New conversation"]
  }) : null;
  var chatHistoryItem = onOpenChatHistory ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
    onSelect: onOpenChatHistory,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.HistoryIcon, {}), "Go to Recent Chats"]
  }) : null;
  var openCustomizeAgent = customizeAgent.kind === "sheet" ? customizeAgent.onOpen : function () {
    return setIsCustomizeAgentDialogOpen(true);
  };
  var customizeAgentDialog = customizeAgent.kind === "dialog" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_customizeAgentDialog.CustomizeAgentDialog, {
    open: isCustomizeAgentDialogOpen,
    onOpenChange: setIsCustomizeAgentDialogOpen,
    onSaved: handleAgentSettingsSaved
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenu, {
      modal: false,
      onOpenChange: function onOpenChange(isOpen) {
        return isOpen && (onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen());
      },
      "data-sentry-element": "DropdownMenu",
      "data-sentry-source-file": "chat-composer-add-menu.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuTrigger, {
        "aria-label": "Add",
        title: "Add",
        className: (0, _button.buttonVariants)({
          variant: "ghost",
          size: "icon-sm"
        }),
        "data-sentry-element": "DropdownMenuTrigger",
        "data-sentry-source-file": "chat-composer-add-menu.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
          "data-sentry-element": "AddIcon",
          "data-sentry-source-file": "chat-composer-add-menu.tsx"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuContent, {
        side: menuSide,
        align: "start",
        className: "w-[234px]",
        "data-testid": "chat-composer-add-menu",
        "data-sentry-element": "DropdownMenuContent",
        "data-sentry-source-file": "chat-composer-add-menu.tsx",
        children: [leadingSection, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
          onSelect: onAttachFile,
          "data-sentry-element": "DropdownMenuItem",
          "data-sentry-source-file": "chat-composer-add-menu.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AttachFileIcon, {
            "data-sentry-element": "AttachFileIcon",
            "data-sentry-source-file": "chat-composer-add-menu.tsx"
          }), "Attach file"]
        }), renderPastChatsEntry(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuSeparator, {
          "data-sentry-element": "DropdownMenuSeparator",
          "data-sentry-source-file": "chat-composer-add-menu.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuLabel, {
          className: "font-normal text-muted-foreground",
          "data-sentry-element": "DropdownMenuLabel",
          "data-sentry-source-file": "chat-composer-add-menu.tsx",
          children: "Library"
        }), LIBRARY_MENU_ENTRIES.map(renderLibraryEntry), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuSeparator, {
          "data-sentry-element": "DropdownMenuSeparator",
          "data-sentry-source-file": "chat-composer-add-menu.tsx"
        }), newConversationItem, chatHistoryItem, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuItem, {
          onSelect: openCustomizeAgent,
          "data-sentry-element": "DropdownMenuItem",
          "data-sentry-source-file": "chat-composer-add-menu.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.BotMessageSquare, {
            "data-sentry-element": "BotMessageSquare",
            "data-sentry-source-file": "chat-composer-add-menu.tsx"
          }), "Customize Agent"]
        }), modelSubmenu]
      })]
    }), customizeAgentDialog]
  });
}